module.exports = __webpack_public_path__ + "img/logo-gmobile.ada70a41.png";